module.exports = __webpack_public_path__ + "942b6bfdf031d606c26a1bf20b47c9a6.svg";